export default {
  path: '/competitor',
  meta: {
    title: '竞品对比',
    // headerStyle: 'blue', // 表头样式类型
    // navBarBackHide: true, // 是否隐藏左侧返回按钮
    // navBarCloseHide: false, // 是否隐藏右侧关闭按钮
    // allowOverscrollBehavior: false, // 是否允许使用浏览器弹性上拉合下滑
    // keepPageScrollY: false, // 是否缓存上一次页面的中间内容部分的滚动位置
  }
};
